import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4105e499"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = ["src"]

import { onMounted, getCurrentInstance, onUnmounted } from 'vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const { proxy }: any = getCurrentInstance()

    const address: string = process.env.VUE_APP_ADDRESS

    onMounted(() => {
        if (proxy.$dd.env.platform !== 'notInDingTalk') {
            proxy.$dd.biz.navigation.hideBar({
                hidden: true
            })
        }
    })

    onUnmounted(() => {
        if (proxy.$dd.env.platform !== 'notInDingTalk') {
            proxy.$dd.biz.navigation.hideBar({
                hidden: false
            })
        }
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      src: _unref(address),
      frameborder: "0"
    }, null, 8, _hoisted_2)
  ]))
}
}

})